import { useState } from "react";
import { Check, Link2, Share2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";

export function chronicleShareUrl(chronicle) {
  return `${window.location.origin}/api/c/${chronicle.slug}`;
}

export function ShareButtons({ chronicle, compact = false }) {
  const [copied, setCopied] = useState(false);
  if (!chronicle?.slug) return null;
  const url = chronicleShareUrl(chronicle);
  const text = chronicle.social_summary || chronicle.title;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Enlace copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copia el enlace", url);
    }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: chronicle.title, text, url }); } catch { /* cancelado */ }
      return;
    }
    copy();
  };
  const cls = `rounded-none border-white/15 bg-transparent font-mono ${compact ? "text-[10px]" : "text-xs"} uppercase tracking-[0.2em] text-slate-200 hover:border-clay/60 hover:bg-clay/10 hover:text-clay`;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`share-buttons-${chronicle.id}`}>
      <Button type="button" variant="outline" onClick={copy} className={cls} data-testid={`share-copy-${chronicle.id}`}>
        {copied ? <Check className="h-3 w-3" /> : <Link2 className="h-3 w-3" />} {copied ? "Copiado" : "Copiar enlace"}
      </Button>
      <Button asChild variant="outline" className={cls}>
        <a href={`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`} target="_blank" rel="noreferrer" data-testid={`share-whatsapp-${chronicle.id}`}>WhatsApp</a>
      </Button>
      <Button asChild variant="outline" className={cls}>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" data-testid={`share-facebook-${chronicle.id}`}>Facebook</a>
      </Button>
      <Button type="button" variant="outline" onClick={share} className={cls} data-testid={`share-native-${chronicle.id}`}><Share2 className="h-3 w-3" /> Compartir</Button>
    </div>
  );
}
